import React, { useState, useEffect } from 'react';
import { Col, Row, theme } from 'antd';
import styles from './styles.module.scss';

interface EmployeeThumbnailProps {
  employeePic: string;
  employeeName: string;
  employeePhone: number | null;
}
const style: React.CSSProperties = { background: '#0092ff', padding: '8px 0' };

const EmployeeThumbnail: React.FC<EmployeeThumbnailProps> = ({
  employeePic,
  employeeName,
  employeePhone,
}: EmployeeThumbnailProps): JSX.Element => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <>
      <Row>
        <img
          className={styles.img}
          src={employeePic}
          onError={(e: any) => {
            e.target.src = '/no_image.png';
          }}
        />

        <Row style={{ wordWrap: 'break-word', marginRight: '10px' }}>
          <p className={styles.description + ' ' + styles.text}>
            {employeeName}
            <br />
            {employeePhone}
          </p>
          <br />
        </Row>
      </Row>
    </>
  );
};

export default EmployeeThumbnail;
